import React from "react";

class Sort extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { sortingSelected, sortingType, column, onUpdateSorting } = this.props;
        
        const isAsc = (typeof column === "object" ? (column.type === "array" ? `${sortingSelected.column.name}_${(sortingSelected.column.data || {}).value}` === `${column.name}_${(column.data || {}).value}` : sortingSelected.column.name === column.name) : sortingSelected.column === column) && sortingSelected.order === "asc";
        const isDesc = (typeof column === "object" ? (column.type === "array" ? `${sortingSelected.column.name}_${(sortingSelected.column.data || {}).value}` === `${column.name}_${(column.data || {}).value}` : sortingSelected.column.name === column.name) : sortingSelected.column === column) && sortingSelected.order === "desc";

        const handleAsc = () => {
            onUpdateSorting("asc");
        }

        const handleDesc = () => {
            onUpdateSorting("desc");
        }

        return (
            <div class="sortByContainer">
                <h4>Sort by</h4>
                {sortingType === "alphabetical" && (
                    <div class="sortingItems">
                        <a class={`sortingItem ${isAsc ? "active" : ""}`} onClick={handleAsc}>Ascending (A-Z) <i class="material-icons">check</i></a>
                        <a class={`sortingItem ${isDesc ? "active" : ""}`} onClick={handleDesc}>Descending (Z-A) <i class="material-icons">check</i></a>
                    </div>
                )}
                {sortingType === "chronological" && (
                    <div class="sortingItems">
                        <a class={`sortingItem ${isAsc ? "active" : ""}`} onClick={handleAsc}>Ascending (Oldest - Newest) <i class="material-icons">check</i></a>
                        <a class={`sortingItem ${isDesc ? "active" : ""}`} onClick={handleDesc}>Descending (Newest - Oldest) <i class="material-icons">check</i></a>
                    </div>
                )}
                {sortingType === "numerical" && (
                    <div class="sortingItems withSortIcon">
                        <a class={`sortingItem ${isAsc ? "active" : ""}`} onClick={handleAsc}>
                            <i class="material-icons sortIcon">arrow_upward</i>
                            Ascending (Least - Greatest)
                        </a>
                        <a class={`sortingItem ${isDesc ? "active" : ""}`} onClick={handleDesc}>
                            <i class="material-icons sortIcon">arrow_downward</i>
                            Descending (Greatest - Least)
                        </a>
                    </div>
                )}
            </div>
        )
    }
}

export default Sort;